var defaultLinks = [{
  label: 'JetBrains home page',
  value: 'https://www.jetbrains.com/'
}, {
  label: 'Products',
  value: 'https://www.jetbrains.com/products.html'
}, {
  label: 'Pricing',
  value: 'https://www.jetbrains.com/store/'
}, {
  label: 'Support',
  value: 'https://www.jetbrains.com/support/'
}];

export { defaultLinks };
